// main router 适配器
export const isMainRouter = (router) => router && router.__type__ === 'main'
